import styled, { css } from 'styled-components';

import { media } from 'app/shared/styles_js/variables';

export const RemarkSt = styled.div`
  width: 100%;
  padding: 0 24px 0 8px;
  word-break: break-word;
  font-size: 16px;

  ${media.md(css`
    margin: 0 8px;
  `)};
`;

export const PreviewTextSt = styled.div`
  position: relative;

  & p {
    display: inline;
  }

  & > p:last-child {
    padding-right: 8px;
  }

  ul {
    margin: 0;
  }
`;

export const TextSt = styled.div`
  & > p:first-child {
    display: inline;
  }
`;
